export const getTableNameFromFQN = (fqn: string) => {
  const parts = fqn.split('.');
  return parts.length > 2 ? parts[2] : null;
};
